export class FeedbackInformation {
  public csatRating: number;

  constructor(data?: FeedbackInformation) {
    Object.assign(this, data);
  }
}
